var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container wysiwig-wrapper detail-container" },
    [
      _c("section", { staticClass: "padded" }, [
        _c("div", { staticClass: "event-details" }, [
          _c(
            "div",
            { staticClass: "split-header" },
            [
              _c(
                "router-link",
                {
                  staticClass: "return-link",
                  attrs: { to: { name: "eventListing" } }
                },
                [_vm._v("< "), _c("p", [_vm._v("Back to Events")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "event-name",
                  class: { noimage: _vm.event.image === "" }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "mobile-return-link",
                      attrs: { to: { name: "eventListing" } }
                    },
                    [_vm._v("< "), _c("p", [_vm._v("Back to Events")])]
                  ),
                  _vm._v(" "),
                  _c("h1", { staticClass: "h2" }, [
                    _vm._v(_vm._s(_vm.event.name))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "event-image",
                  class: { noimage: _vm.event.image === "" }
                },
                [
                  _vm.event.image
                    ? _c("img", {
                        attrs: { src: _vm.event.image, alt: _vm.event.name }
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "event-stats" }, [
            _c("div", { staticClass: "stat" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.parsedStartDate))]),
              _vm._v(" "),
              _vm.parsedEndDate !== "" &&
              _vm.parsedEndDate != _vm.parsedStartDate
                ? _c("p", [_vm._v("to " + _vm._s(_vm.parsedEndDate))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.event.startTime))]),
              _vm._v(" "),
              _vm.event.endTime
                ? _c("p", [_vm._v("to " + _vm._s(_vm.event.endTime))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.event.eventStoreLocation))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.event.eventAddress))])
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "event-description",
            domProps: { innerHTML: _vm._s(_vm.event.description) }
          }),
          _vm._v(" "),
          _vm.event.eventBrightUrl !== ""
            ? _c(
                "a",
                {
                  staticClass: "btn",
                  attrs: { href: _vm.event.eventBrightUrl, target: "_blank" }
                },
                [_vm._v("Get Tickets")]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Date:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Time:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Location:")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }